import { useMemo } from 'react';
import { ImageStyle, ImageURISource, View } from 'react-native';
import { Avatar } from '@kolking/react-native-avatar';

import { CachedImage } from '../CachedImage';
import { PremiumIndicator } from './PremiumIndicator';
import { Text } from '../Text';
import { colors } from '../../theme';

const DEFAULT_SIZE = 20;

export const UserAvatar = ({
	username,
	size = DEFAULT_SIZE,
	source,
	style,
	isPremium = false,
	userCount = 0,
	colorize = true,
}: Props) => {
	const styles = useMemo(() => getStyles(size, style), [size, style]);

	const premiumStyle = isPremium
		? {
				borderWidth: size / 30,
				borderColor: '#FFD54D',
			}
		: undefined;

	const userImage = source ? (
		<CachedImage source={source} style={[styles.avatar, premiumStyle]} />
	) : (
		<Avatar
			colorize={colorize}
			name={username}
			size={size}
			style={{ ...styles.avatar, ...(premiumStyle || {}) }}
		/>
	);

	return (
		<PremiumIndicator size={size} isPremium={isPremium}>
			{userImage}
			{userCount > 1 ? (
				<View style={styles.userCount}>
					<Text appearance="hint" category="s2">
						+{--userCount}
					</Text>
				</View>
			) : null}
		</PremiumIndicator>
	);
};

type Props = {
	username: string;
	source?: ImageURISource;
	style?: ImageStyle;
	size?: number;
	isPremium?: boolean;
	userCount?: number;
	colorize?: boolean;
};

const getStyles = (size: number, style?: ImageStyle) => ({
	avatar: {
		width: size,
		height: size,
		borderRadius: size / 2,
		...style,
	},
	userCount: {
		width: 24,
		height: 24,
		backgroundColor: colors.white,
		borderRadius: 12,
		position: 'absolute',
		bottom: -4,
		right: -4,
		justifyContent: 'center',
		alignItems: 'center',
	},
});
